import { useState } from 'react';
import { Card, CardContent, CardMedia, Typography, Box, Paper } from '@mui/material';

const mockInformationItems = [
  {
    id: 1,
    title: 'Information Item 1',
    image: 'https://via.placeholder.com/300x200',
    description: 'This is a sample information item'
  },
  {
    id: 2,
    title: 'Information Item 2',
    image: 'https://via.placeholder.com/300x200',
    description: 'This is another sample information item'
  },
  {
    id: 3,
    title: 'Information Item 3',
    image: 'https://via.placeholder.com/300x200',
    description: 'This is yet another sample information item'
  }
];

function Information() {
  const [selectedItem, setSelectedItem] = useState(mockInformationItems[0]);

  return (
    <Box sx={{ flexGrow: 1, height: '100%', display: 'flex' }}>
      <Box sx={{
        width: '200px',
        padding: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        overflowY: 'auto'
      }}>
        {mockInformationItems.map((item) => (
          <Card
            key={item.id}
            onClick={() => setSelectedItem(item)}
            sx={{
              cursor: 'pointer',
              border: selectedItem.id === item.id ? '2px solid #ff5722' : 'none',
              '&:hover': {
                boxShadow: 4
              }
            }}
          >
            <CardMedia
              component="img"
              height="140"
              image={item.image}
              alt={item.title}
            />
            <CardContent>
              <Typography variant="body2" color="text.secondary">
                {item.title}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>

      <Box sx={{ flex: 1, padding: 2, display: 'flex', flexDirection: 'column' }}>
        <Paper elevation={3} sx={{
          padding: 3,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto'
        }}>
          <Typography variant="h4" gutterBottom>
            {selectedItem.title}
          </Typography>
          <img
            src={selectedItem.image}
            alt={selectedItem.title}
            style={{ width: '100%', maxHeight: '400px', objectFit: 'cover', marginBottom: '20px' }}
          />
          <Typography variant="body1" paragraph>
            {selectedItem.description}
          </Typography>
          <Typography variant="body1" paragraph>
            Additional information and details will be displayed here.
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
}

export default Information;
